// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2amt3","label":"styles_label__2srwR"};